import React from 'react';
import { useLocation } from 'react-router-dom';

import { Box } from '@mui/material';

import EventsDropdown from './EventsDropdown';
import FullScreenButton from '@components/FullScreenButton';
import BackButton from '@components/BackButton';
import UserAvatarButton from '@components/UserAvatarButton';
import LogoutButton from '@components/LogoutButton';
import LanguageButton from '@components/LanguageButton';
import LoginLanguageSwitcher from './LoginLanguageSwitcher';
import ROUTES from '@constants/routes';

import { IAppHeader } from './interfaces';

import { useStyles } from './styles';

const AppHeader = ({
  isAuthorized = false,
  showEventsDropdown = false,
  showUserAvatarButton = false,
  showLanguageButton = false,
  lightIconColor = false,
  onBackClick,
}: IAppHeader) => {
  const classes = useStyles(lightIconColor);
  const { pathname } = useLocation();
  const isLoginPage = pathname === ROUTES.LOGIN;

  return (
    <Box sx={classes.root}>
      <Box sx={classes.box}>
        {!!onBackClick && <BackButton onClick={onBackClick} />}
      </Box>
      {showEventsDropdown && (
        <EventsDropdown
          sx={classes.eventsDropdown}
          menuProps={{ MenuListProps: { sx: classes.menuList } }}
        />
      )}
      <Box sx={classes.actionsContainer}>
        {isLoginPage && <LoginLanguageSwitcher />}
        <FullScreenButton />
        {isAuthorized ? (
          <>
            {showUserAvatarButton && <UserAvatarButton />}
            <LogoutButton />
          </>
        ) : (
          showLanguageButton && <LanguageButton />
        )}
      </Box>
    </Box>
  );
};

export default AppHeader;
